import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { getAddChannel, addChannel, returnData, updataChannel } from "@/api/loginConfig/userChannel";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    num: {
      type: Number // default: "1",

    }
  },
  data: function data() {
    return {
      titleName: "",
      dialogFormVisible: false,
      id: "",
      searchData: {
        channel: ""
      },
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      advchannels: [],
      pay_types: [],
      gameId: "",
      searchMark: {},
      rules: {
        channel: [{
          required: true,
          message: '请选择渠道',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    if (this.num == 1) {
      this.searchData = {};
      this.titleName = "新增统一用户渠道";
    }

    getAddChannel().then(function (res) {
      _this.searchchannels = res.data;
    });
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.show) {
          v;
          return this.show;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$returnData, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (!(num == 2)) {
                  _context.next = 15;
                  break;
                }

                _this2.titleName = "修改统一用户渠道";
                _this2.form = {};
                tid = {
                  id: id
                };
                _context.next = 7;
                return returnData(tid);

              case 7:
                _yield$returnData = _context.sent;
                data = _yield$returnData.data;
                _this2.searchData.channel = data.info.channel;

                _this2.$forceUpdate();

                _this2.searchMark.channel = data.info.channel;
                _this2.searchMark.id = data.info.id;
                _context.next = 16;
                break;

              case 15:
                _this2.titleName = "新增统一用户渠道";

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    channelchange: function channelchange(val) {
      this.searchMark.channel = val;
      this.$forceUpdate();
    },
    resetForm: function resetForm(formName) {
      this.searchData = {};
      this.isShow = false;
      this.formName = "";
      this.dialogFormVisible = false;
      this.clearData();
      this.$emit("refreshDataList");
      this.$emit("refreshDataListing");
      this.$emit("changeShow", false);
    },
    dataReset: function dataReset() {
      this.dialogFormVisible = false;
    },
    // 重置
    clearData: function clearData() {
      this.searchData = {
        channel: ""
      };
      this.$refs.ruleForm.resetFields();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this3.titleName == "新增统一用户渠道") {
            addChannel(_this3.searchMark).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message);

                _this3.resetForm("ruleForm");

                _this3.clearData();
              }
            });
          } else {
            updataChannel(_this3.searchMark).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message);

                _this3.resetForm("ruleForm");

                _this3.clearData();
              }
            });
          }
        }
      });
    }
  }
};